module.exports = __webpack_public_path__ + "static/img/bg_unfit_bag.4ef574f5.png";